import { CompressionAndExport } from '@/app/workflows/actions/interfaces';

type CompressionMethod = NonNullable<
  NonNullable<CompressionAndExport['fileExports'][number]['textureFormat']>['baseColor']
>;

type Filetype = CompressionAndExport['fileExports'][number]['fileType'];
export type TextureFormatOption = {
  label: string;
  value: CompressionMethod | 'custom';
  disabled?: boolean;
};

const filetypesAllowingAllTextureFormats: Filetype[] = ['glb', 'gltf'];

const limitedFormats: TextureFormatOption[] = [
  { label: 'Auto', value: 'auto' },
  { label: 'jpg', value: 'jpg' },
  { label: 'png', value: 'png' },
  { label: 'custom', value: 'custom', disabled: true },
];

export const allTextureFormatOptions: TextureFormatOption[] = [
  ...limitedFormats,
  { label: 'ktx-basis-uastc', value: 'ktx-basis-uastc' },
  { label: 'ktx-basis-etcs1', value: 'ktx-basis-etcs1' },
  { label: 'webp', value: 'webp' },
];

export function getAllowedTextureFormats(filetype: Filetype) {
  return filetypesAllowingAllTextureFormats.includes(filetype) ? allTextureFormatOptions : limitedFormats;
}
